import cx from "classnames";

import Tooltip from "ds/components/Tooltip";
import Icon, { IconProps } from "ds/components/Icon";
import { TooltipProps } from "ds/components/Tooltip/types";

type IconWithTooltipProps = {
  icon: IconProps["src"];
  tooltip: string;
  tooltipWidthMode?: TooltipProps["widthMode"];
  className?: string;
  size?: IconProps["size"];
  noShrink?: IconProps["noShrink"];
  color?: IconProps["color"];
};

const IconWithTooltip = ({
  icon,
  tooltip,
  tooltipWidthMode,
  className,
  size,
  noShrink,
  color,
}: IconWithTooltipProps) => {
  return (
    <Tooltip
      widthMode={tooltipWidthMode}
      on={(props) => (
        <Icon
          aria-label={tooltip}
          aria-hidden={false}
          src={icon}
          size={size}
          noShrink={noShrink}
          color={color}
          {...props}
          className={cx(className, props.className)}
        />
      )}
    >
      {tooltip}
    </Tooltip>
  );
};

export default IconWithTooltip;
